import { createSlice } from '@reduxjs/toolkit';

import { Member } from '../../../types/entity.types';
import {
  MemberState,
  SetMemberBadgesPayload,
  SetMemberPayload,
  SetMembersPayload,
  UpdateMemberBadgesPayload,
  UpdateMemberDeviceIdPayload
} from './member.types';

export const initialState: MemberState = {
  member: undefined,
  members: [],
  memberBadges: undefined
};

const MemberSlice = createSlice({
  name: 'member',
  initialState,
  reducers: {
    setMember: (state, action: SetMemberPayload) => {
      state.member = action.payload;
    },
    setMembers: (state, action: SetMembersPayload) => {
      state.members = action.payload;
    },
    setMemberBadges: (state, action: SetMemberBadgesPayload) => {
      state.memberBadges = action.payload;
    },
    updateMemberBadges: (state, action: UpdateMemberBadgesPayload) => {
      const member = state.members.find(
        (member) => member.externalReference === action.payload.memberExternalReference
      ) as Member;

      if (member) {
        const badgeCount = action.payload.badges.reduce((total, element) => total + element.badgeCount, 0);
        member.memberBadges = action.payload.badges;
        member.badgeCount = badgeCount;
      }
    },
    updateMemberDeviceId: (state, action: UpdateMemberDeviceIdPayload) => {
      const member = state.members.find(
        (member) => member.systemUserExternalReference === action.payload.systemUserExternalReference
      ) as Member;

      if (member) {
        member.deviceId = action.payload.deviceId;
      }
    }
  }
});

export const { setMember, setMembers, setMemberBadges, updateMemberBadges, updateMemberDeviceId } = MemberSlice.actions;

export default MemberSlice.reducer;
